import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { resetFirstLastMargins } from '@/css/resources/placeholders.css';
import { transitions } from '@/css/resources/variables.css';
import {
	expandLink,
	fluidValues,
	fontStyle,
	fluidPadding,
	fluidMargin,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidBorderWidth(styles?.border?.width),
		fluidBorderRadius(styles?.border?.radius),
		{
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,
			flexDirection: styles?.direction,
			background: styles?.backgroundColor,
			borderColor: styles?.border?.color,

			'.supt-cardPeople__content': fluidPadding(styles?.padding),

			'.supt-cardPeople__image': cssObj(
				fluidValues(
					'width',
					styles?.image?.width?.[0],
					styles?.image?.width?.[1]
				),
				fluidValues(
					'height',
					styles?.image?.height?.[0],
					styles?.image?.height?.[1]
				),
				fluidMargin(styles?.image?.margin),
				{
					/* stylelint-disable-next-line */
					figure: cssObj(
						fluidBorderWidth(styles?.image?.border?.width),
						fluidBorderRadius(styles?.image?.border?.radius),
						{
							borderColor: styles?.image?.border?.color,
						}
					),
				}
			),

			'.supt-cardPeople__name': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'.supt-cardPeople__role': fontStyle({
				...styles?.role?.typography,
				textAlign: styles?.role?.textAlignment,
				color: styles?.role?.color,
			}),

			'.supt-cardPeople__blocks a': fontStyle({
				...styles?.link?.typography,
				textAlign: styles?.link?.textAlignment,
				color: styles?.link?.color,
			}),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		display: 'flex',
		alignItems: 'center',
		borderStyle: 'solid',

		'.supt-cardPeople__content': {
			width: '100%',
		},

		'.supt-cardPeople__image': {
			display: 'block',
			flex: '0 0 auto',
			maxWidth: '100%',

			figure: {
				width: '100%',
				height: '100%',
				overflow: 'hidden',
				position: 'relative',
				borderStyle: 'solid',
			},

			img: {
				objectFit: 'cover',
			},
		},

		'.supt-cardPeople__name, .supt-cardPeople__role': resetFirstLastMargins,

		'.supt-cardPeople__blocks': {
			marginTop: '5px',

			/* stylelint-disable-next-line */
			a: cssObj(resetFirstLastMargins, {
				display: 'block',
			}),
		},

		/* with link */
		'&.supt-isClickAreaExpanded': cssObj(expandLink(), {
			transition: `all ${transitions.mid} ease-out`,

			'.supt-cardPeople__name, .supt-cardPeople__role, .supt-cardPeople__blocks a':
				{
					transition: `all ${transitions.mid} ease-out`,
				},

			'&:hover, &:focus-within': getDynamicStyles(styles?.states?.hover),
		}),
	});

// edit
const getEditGlobalStyles = (styles) =>
	cssObj({
		'.wp-block[data-type="supt/card-people"]': {
			display: 'flex',
			width:
				styles?.minWidth &&
				styles?.maxWidth &&
				`clamp(${styles?.minWidth}, 100%, ${styles?.maxWidth})`,

			'figure > button + button': {
				top: '50%',
				right: '50%',

				transform: 'translate3d(50%, -50%, 0)',
			},

			'figure img': {
				minWidth: '100%',
				minHeight: '100%',
			},

			a: {
				textDecoration: 'none',

				'&::before': {
					display: 'none',
				},
			},

			'.supt-card': {
				flex: 1,
			},
		},
	});

export { getStyles, getEditGlobalStyles };
